(function () {
    'use strict';

    angular.module('app.shipmentProvider', [
        // Angular modules 
        'ngRoute'

        // Custom modules 

        // 3rd Party Modules
        
    ]);
})();